import { createConfirmation } from 'react-confirm';
import Confirmation from './Confirmation';

const confirm = createConfirmation(Confirmation);

export default function(confirmation: $TSFixMe, options = {}) { // eslint-disable-line
  return confirm({ confirmation, ...options });
}
